import React, { useEffect } from "react";
import { Navigate, Route } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import { useProfile } from "../Components/Hooks/UserHooks";

import { logoutUser, profileSuccess } from "../store/actions";
import { getAllRoles } from "../store/roles/actions";
import { useParams } from "react-router-dom";
import { projectUserSuccess } from "../store/projectUser/actions";
import { setCurrentProjectRole } from "../store/roles";
import { Role } from "../constants/Role";
import { AutoLogout } from "./AutoLogout";

const AuthProtected = (props) => {
  const dispatch = useDispatch();
  const params = useParams()
  const { user } = useSelector((state) => ({
    user: state.Profile.user,
  }));
  const { projectUser } = useSelector((state) => ({
    projectUser: state.projectUser.projectUser,
  }));

  const { token } = useProfile();

  AutoLogout();

  useEffect(() => {
    const projectId = params.project ?? params.projectId
    if ((projectId) && (projectUser === undefined || projectUser.projectId !== parseInt(projectId) ) ) {
      axios.get(`project-user/${parseInt(projectId)}`).then((response) => {
        dispatch(projectUserSuccess(response.data))
        dispatch(setCurrentProjectRole({role: response.data.data.role.name, project: response.data.data.project}))
      }).catch((err) => {
        console.error(err)
      })
    }
  }, [params.project, params.projectId] )

  useEffect(() => {
    if (!user && token) {
      setAuthorization(token);
      axios.get('/me').then((response) => {
        dispatch(profileSuccess(response.data))
        dispatch(getAllRoles())
        const role = response.data.data.role
        if ([Role.EPMO_OFFICER, Role.ROOT_ADMIN, Role.EPMO_MANAGER, Role.PORTFOLIO_MANAGER, Role.PROGRAM_MANAGER, Role.VICE_PRESIDENT, Role.PRESIDENT, Role.MENTOR].includes(role?.name)) {
          dispatch(projectUserSuccess(response.data))
          dispatch(setCurrentProjectRole({role: role.name, project: null}))
        }
      }).catch((err) => {
        console.error(err)
        dispatch(logoutUser());
      })
    } else if (!user && !token) {
      dispatch(logoutUser());
    }
  }, [token, user]);

  /*
    redirect is un-auth access protected routes via url
  */

  if (!token) {
    return (
      <Navigate to={{ pathname: "/login", state: { from: props.location } }} />
    );
  }
  if ((params.project ?? params.projectId) && projectUser) {
    return <>{user && projectUser && props.children}</>;
  }
  return <>{user && props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };